const clientIdInput = document.getElementById('ga_client_id');
const sessionIdInput = document.getElementById('ga_session_id');
const sessionNumberInput = document.getElementById('ga_session_number');

function fetchClientId() {
  if (typeof window.ga === 'undefined') {
    setTimeout(fetchClientId, 2000);
    return;
  }

  window.ga(() => {
    const t = window.ga.getAll();
    let clientId;

    if (t && t.length) {
      clientId = t[0].get('clientId');
      clientIdInput.value = clientId;
    } else {
      setTimeout(fetchClientId, 2000);
    }
  });
}

function fetchSessionId() {
  if (!window.ga4StreamId) {
    setTimeout(fetchSessionId, 1000);
    return;
  }

  const { cookie } = document;

  // When cookies are empty, retry later.
  if (!cookie) {
    setTimeout(fetchSessionId, 1000);
    return;
  }

  const cookieName = `_ga_${window.ga4StreamId.replace('G-', '')}`;

  const gaStreamCookies = cookie
    .split(';')
    .map((ck) => ck.trim())
    .filter((ck) => ck.indexOf(cookieName) >= 0);

  // When a GA4 cookie can't be found or seems invalid (missing =)
  if (!gaStreamCookies.length || gaStreamCookies[0].indexOf('=') < 0) {
    setTimeout(fetchSessionId, 1000);
    return;
  }

  const val = gaStreamCookies[0].split('=')[1];

  // Retrieve the Session ID and Session number from the ID. An example ID is:
  // > GS1.1.1682323480.1.0.1682325454.0.0.0
  // We extract 1682323480 (session ID) and 1 (session number)
  const match = val.match(/GS\d\.\d\.(\d+)\.(\d+)/);

  // If the regex could not match the correct values, retry later.
  if (!match || typeof match[1] === 'undefined' || typeof match[2] === 'undefined') {
    setTimeout(fetchSessionId, 1000);
    return;
  }

  // eslint-disable-next-line prefer-destructuring
  sessionIdInput.value = match[1];
  // eslint-disable-next-line prefer-destructuring
  sessionNumberInput.value = match[2];
}

if (clientIdInput) {
  fetchClientId();
}

if (sessionIdInput && sessionNumberInput) {
  fetchSessionId();
}
